module.exports = __webpack_public_path__ + "img/ayanda-profile-min.0a7ff855.jpg";